import React, { useContext, useState } from "react";
import { Typography } from "@mui/material";

import BottomFade from "../components//Fade";
import { LangContext } from "../contexts/langContext";
import { green } from "../config";
import { TranslationData } from "@common";

interface SearchResultLinkProps {
  url: TranslationData;
  title: TranslationData;
  type: string;
  metaDesc: TranslationData;
  index: number;
  correctLinkIndex: number;
  dark: MediaQueryList;
  mobile: boolean;
  pointsController: (index: number) => void;
  readOnly: boolean;
  showCorrect: boolean;
}

const SearchResultLink: React.FC<SearchResultLinkProps> = ({
  url,
  title,
  type,
  metaDesc,
  index = 0,
  correctLinkIndex = 0,
  dark = false,
  mobile = false,
  pointsController = (index: number) => undefined,
  readOnly = false,
  showCorrect = false,
}) => {
  const { translateTranslationData, translatePageText } = useContext(LangContext);
  const [hover, setHover] = useState(false);
  const handleClick = () => pointsController(index);

  return (
    <BottomFade fadeOnMobile={true}>
      <div
        style={{
          margin: "0 0 20px 0",
          cursor: readOnly ? "default" : "pointer",
          border: correctLinkIndex === index && showCorrect ? "2px solid " + green[400] : undefined,
          borderRadius: correctLinkIndex === index ? 4 : undefined,
          padding: correctLinkIndex === index ? 4 : undefined,
        }}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        onClick={() => (!readOnly ? handleClick() : undefined)}
      >
        {correctLinkIndex === index && showCorrect && (
          <Typography style={{ marginTop: -21, fontSize: 11, color: green[500] }}>
            {translatePageText("test.correctAnswer")}
          </Typography>
        )}

        <div
          style={{
            display: "flex",
          }}
        >
          {type === "ad" ? (
            <span
              style={{
                fontSize: "0.6em",
                padding: "1px 5px",
                color: "#1d2342",
                fontWeight: "bold",
                borderRadius: 4,
                backgroundColor: "#f1c232",
                marginRight: 6,
              }}
            >
              {translatePageText("general.ad")}
            </span>
          ) : null}
          <span
            style={{
              display: "block",
              fontSize: "0.7em",
              opacity: 0.9,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {translateTranslationData(url)}
          </span>
          <span
            style={{
              fontSize: "0.65em",
              marginLeft: 5,
              color: "#7d9efa",
            }}
          >
            &#9660;
          </span>
        </div>
        <span
          style={{
            margin: "3px 0",
            display: "block",
            color: dark ? "inherit" : "#0b5394",
            textDecoration: !hover ? "none" : readOnly ? "none" : "underline",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            width: "95%",
          }}
        >
          {translateTranslationData(title)}
        </span>
        <p
          style={{
            margin: "0 0 1px 0",
            fontSize: mobile ? "0.7em" : "0.8em",
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: mobile ? "-webkit-box" : "block",
            WebkitLineClamp: mobile ? "2" : "none",
            lineClamp: mobile ? "2" : "none",
            WebkitBoxOrient: mobile ? "vertical" : "unset",
          }}
        >
          {translateTranslationData(metaDesc)}
        </p>
      </div>
    </BottomFade>
  );
};

export default SearchResultLink;
